module.exports = __webpack_public_path__ + "static/media/modernRoom.601c46a4.png";